module.exports = __webpack_public_path__ + "static/media/drop-1@1x.2caf19c5.png";